import CheckedError from "./CheckedError";
export default class InstructionParsingError extends CheckedError {
    constructor(message, inputString) {
        super(message);
        this.inputString = inputString;
    }
}
